import { Banner, DropZone, Thumbnail } from "@shopify/polaris"
import { NoteMinor } from "@shopify/polaris-icons"
import { useCallback, useState } from "react"

const DropZoneImg = ({ blockedPageImg, setBlockedPageImg }) => {
	const [error, setError] = useState("")

	const handleDropZoneDrop = useCallback(
		(dropFiles, acceptedFiles, rejectedFiles) => {
			if (rejectedFiles.length > 0) {
				setError(
					"The selected image is not valid. Check that the filesize doesn't exceed 60kb",
				)
				setBlockedPageImg(null)
			} else if (acceptedFiles[0]) {
				setBlockedPageImg(acceptedFiles[0])
				setError("")
			} else {
				setError("")
			}
		},
		[],
	)

	const validateFile = (e) => {
		if (e.size < 60000) {
			return true
		} else {
			return false
		}
	}

	const validImageTypes = ["image/gif", "image/jpeg", "image/png"]

	const fileUpload = !blockedPageImg && <DropZone.FileUpload />
	const uploadedFile = blockedPageImg && (
		<div
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "100%",
			}}
		>
			<Thumbnail
				size="large"
				alt={blockedPageImg.name}
				source={
					validImageTypes.includes(blockedPageImg.type)
						? window.URL.createObjectURL(blockedPageImg)
						: NoteMinor
				}
			/>
		</div>
	)

	return (
		<div id="something" style={{ marginBottom: "0.5rem" }}>
			<DropZone
				allowMultiple={false}
				onDrop={handleDropZoneDrop}
				accept={validImageTypes.join(",")}
				customValidator={validateFile}
				error={error.length > 0}
				errorOverlayText={error}
			>
				{uploadedFile}
				{fileUpload}
			</DropZone>

			{error && (
				<div style={{ marginTop: "1rem" }}>
					<Banner status="critical">{error}</Banner>
				</div>
			)}
		</div>
	)
}

export default DropZoneImg
